import { Link, useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { useEffect, useState } from "react";
import AnimatedPage from "../components/AnimatedPage";
import axios from "axios";
import swal from "sweetalert";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";

// Danh sách ngân hàng tích hợp sẵn
const banksList = [
    { vn_name: "Ngân hàng NN & PTNT VN", shortName: "Agribank", bankCode: "204", logo: "https://api.vietqr.io/img/ICB.png" },
    { vn_name: "Ngân hàng Đầu tư và Phát triển Việt Nam", shortName: "BIDV", bankCode: "202", logo: "https://api.vietqr.io/img/BIDV.png" },
    { vn_name: "Ngân hàng TMCP Ngoại Thương", shortName: "Vietcombank", bankCode: "203", logo: "https://api.vietqr.io/img/VCB.png" },
    { vn_name: "Ngân hàng công thương Việt Nam", shortName: "Vietinbank", bankCode: "201", logo: "https://iocrealty.com/wp-content/uploads/images/y-nghia-sau-sac-dang-sau-thiet-ke-logo-vietinbank-0.png" },
    { vn_name: "Ngân hàng Kỹ thương Việt Nam", shortName: "Techcombank", bankCode: "310", logo: "https://api.vietqr.io/img/TCB.png" },
    { vn_name: "Ngân hàng Thương mại cổ phần Việt Nam Thịnh Vượng", shortName: "VPBank", bankCode: "309", logo: "https://api.vietqr.io/img/VPB.png" },
    { vn_name: "Ngân hàng Quân Đội", shortName: "MB", bankCode: "311", logo: "https://api.vietqr.io/img/MB.png" },
    { vn_name: "Ngân hàng Á Châu", shortName: "ACB", bankCode: "307", logo: "https://api.vietqr.io/img/ACB.png" },
    { vn_name: "Ngân hàng Sài Gòn Thương Tín", shortName: "Sacombank", bankCode: "303", logo: "https://api.vietqr.io/img/STB.png" },
    { vn_name: "Ngân hàng Sài Gòn - Hà Nội", shortName: "SHB", bankCode: "348", logo: "https://api.vietqr.io/img/SHB.png" },
    { vn_name: "Ngân hàng Phát triển TP HCM", shortName: "HDBank", bankCode: "321", logo: "https://api.vietqr.io/img/HDB.png" },
    { vn_name: "Ngân hàng Quốc tế", shortName: "VIB", bankCode: "314", logo: "https://api.vietqr.io/img/VIB.png" },
    { vn_name: "Ngân hàng Phương Đông", shortName: "OCB", bankCode: "333", logo: "https://api.vietqr.io/img/OCB.png" },
    { vn_name: "Ngân hàng Hàng Hải Việt Nam", shortName: "MSB", bankCode: "302", logo: "https://api.vietqr.io/img/MSB.png" },
    { vn_name: "Ngan hàng TMCP Bưu điện Liên Việt", shortName: "LPB", bankCode: "357", logo: "https://api.vietqr.io/img/LPB.png" },
    { vn_name: "Ngân hàng An Bình", shortName: "ABBank", bankCode: "323", logo: "https://api.vietqr.io/img/ABB.png" },
    { vn_name: "Ngân hàng Xuất nhập khẩu Việt Nam", shortName: "Eximbank", bankCode: "305", logo: "https://api.vietqr.io/img/EIB.png" },
    { vn_name: "Ngân hàng TMCP Đông Nam Á", shortName: "SeABank", bankCode: "317", logo: "https://media.loveitopcdn.com/3807/logo-seabank-compressed.jpg" },
    { vn_name: "Ngân hàng Đông Á", shortName: "Dong A Bank", bankCode: "304", logo: "https://api.vietqr.io/img/DOB.png" },
    { vn_name: "Ngân hàng Nam Á", shortName: "Nam A Bank", bankCode: "306", logo: "https://api.vietqr.io/img/NAB.png" }
];

function WithDraw() {
    const [profile, setProfile] = useState(JSON.parse(localStorage.getItem("profile")));
    const [vndBanks, setVndBanks] = useState([]);
    const [usdtBanks, setUsdtBanks] = useState([]);
    const [newMoney, setNewMoney] = useState("");
    const [setting, setSetting] = useState(JSON.parse(localStorage.getItem("setting")));
    
    const [usdtRate, setUsdtRate] = useState(26337); 
    const [pendingAmount, setPendingAmount] = useState(0);

    const [load, setLoad] = useState(false);
    const [initialLoading, setInitialLoading] = useState(true);
    
    const [showPwd, setShowPwd] = useState(false);
    const [withdrawMethod, setWithdrawMethod] = useState("VND");
    
    // --- STATE KIỂM TRA XEM CÓ CẦN TẠO MẬT KHẨU RÚT TIỀN KHÔNG ---
    const [needsPayPwd, setNeedsPayPwd] = useState(false);
    // -------------------------------------------------------------

    const [showAddBankPopup, setShowAddBankPopup] = useState(false);
    const [showAddUsdtPopup, setShowAddUsdtPopup] = useState(false);
    const [showPendingPopup, setShowPendingPopup] = useState(false);

    const [searchTerm, setSearchTerm] = useState("");
    const [isOpen, setIsOpen] = useState(false);
    
    const filteredBanksList = banksList.filter(b => 
        b.vn_name.toLowerCase().includes(searchTerm.toLowerCase()) || 
        b.shortName.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const navigate = useNavigate();

    axios.interceptors.request.use(
        (config) => {
            const token = localStorage.getItem("user");
            if (token) {
                config.headers["Authorization"] = `Bearer ${token}`;
            }
            return config;
        },
        (error) => Promise.reject(error)
    );

    const { register: regWithdraw, handleSubmit: handleWithdraw, setValue: setWValue, formState: { errors: wErrors } } = useForm();
    const { register: regBank, handleSubmit: handleAddBank, reset: resetBankForm, setValue: setBankValue, formState: { errors: bErrors } } = useForm();
    const { register: regUsdt, handleSubmit: handleAddUsdt, reset: resetUsdtForm, formState: { errors: uErrors } } = useForm();

    const handleBackClick = () => navigate(-1);

    const fetchBankData = (currentMethod = withdrawMethod) => {
        setInitialLoading(true);
        axios.get(`${process.env.REACT_APP_API_URL}/bank/getBank`)
            .then((res) => {
                if (res.data.data) {
                    const allBanks = res.data.data;
                    const vnds = allBanks.filter(b => !['TRC20', 'BEP20', 'USDT'].includes(b.name_bank.toUpperCase()));
                    const usdts = allBanks.filter(b => ['TRC20', 'BEP20', 'USDT'].includes(b.name_bank.toUpperCase()));
                    
                    setVndBanks(vnds);
                    setUsdtBanks(usdts);

                    if (currentMethod === 'VND') {
                        setShowAddBankPopup(vnds.length === 0);
                        setShowAddUsdtPopup(false);
                    } else if (currentMethod === 'USDT') {
                        setShowAddUsdtPopup(usdts.length === 0);
                        setShowAddBankPopup(false);
                    }
                } else {
                    if (currentMethod === 'VND') setShowAddBankPopup(true);
                    if (currentMethod === 'USDT') setShowAddUsdtPopup(true);
                }
            })
            .catch(() => {
                if (currentMethod === 'VND') setShowAddBankPopup(true);
                if (currentMethod === 'USDT') setShowAddUsdtPopup(true);
            })
            .finally(() => setInitialLoading(false));
    };

    useEffect(() => {
        setInitialLoading(true); 
        axios.get(`${process.env.REACT_APP_API_URL}/auth/getUser`)
            .then((res) => {
                const userData = res.data.data;
                setProfile(userData);
                localStorage.setItem("profile", JSON.stringify(userData));

                // NẾU CHƯA CÓ MẬT KHẨU -> Bật cờ needsPayPwd lên để form hiển thị thêm ô tạo mật khẩu
                if (!userData.paypwd || userData.paypwd === "0" || userData.paypwd === "") {
                    setNeedsPayPwd(true);
                } else {
                    setNeedsPayPwd(false);
                }
                
                fetchBankData("VND"); 
            })
            .catch(() => {
                localStorage.removeItem("user");
                setInitialLoading(false);
                navigate("/login");
            });

        axios.get(`${process.env.REACT_APP_API_URL}/setting/get`).then((res) => {
            setSetting(res.data.data[0]);
            localStorage.setItem("setting", JSON.stringify(res.data.data[0]));
        });

        axios.get("https://api.coingecko.com/api/v3/simple/price?ids=tether&vs_currencies=vnd")
            .then(res => {
                if (res.data?.tether?.vnd) setUsdtRate(res.data.tether.vnd);
            }).catch(() => {});

        axios.get(`${process.env.REACT_APP_API_URL}/payment/paymentus`)
            .then((res) => {
                if (res.data && res.data.data) {
                    const pendingList = res.data.data.filter(p => p.type_payment === "RÚT" && p.status_payment === "Pending");
                    const totalPending = pendingList.reduce((sum, p) => sum + p.money, 0);
                    setPendingAmount(totalPending);
                }
            }).catch(() => {});
    }, []);

    const handleSwitchMethod = (method) => {
        setWithdrawMethod(method);
        setWValue("detail", ""); 
        
        if (method === "VND") {
            setShowAddUsdtPopup(false);
            if (vndBanks.length === 0) setShowAddBankPopup(true);
        } else if (method === "USDT") {
            setShowAddBankPopup(false);
            if (usdtBanks.length === 0) setShowAddUsdtPopup(true);
        }
    };

    const handleQuickAmount = (val) => {
        const formatted = val.toLocaleString('vi-VN');
        setNewMoney(formatted);
        setWValue("money", formatted);
    };

    const handleMaxAmount = () => {
        if (profile?.money) {
            const formatted = profile.money.toLocaleString('vi-VN');
            setNewMoney(formatted);
            setWValue("money", formatted);
        }
    };

    const onSubmitWithdraw = (data) => {
        if (load) return;
        const rawMoney = Number(data.money.replaceAll(".", "").replaceAll(",", ""));

        if (rawMoney > profile.money) return swal("Thất bại", "Số dư không đủ", "error");
        if (rawMoney <= 0 || isNaN(rawMoney)) return swal("Thất bại", "Số tiền không hợp lệ", "error");
        if (rawMoney < setting?.minrut) return swal("Chú ý", `Rút tối thiểu là ${(setting?.minrut).toLocaleString('vi-VN')} VNĐ`, "warning");
        if (rawMoney > setting?.maxrut) return swal("Chú ý", `Rút tối đa là ${(setting?.maxrut).toLocaleString('vi-VN')} VNĐ`, "warning");

        let finalDetail = data.detail;
        if (withdrawMethod === "USDT") {
            const usdtAmount = (rawMoney / usdtRate).toFixed(2);
            finalDetail = `${data.detail} (Nhận: ${usdtAmount} USDT)`;
        }

        const formData = {
            money: rawMoney, 
            type_payment: "RÚT",
            detail: finalDetail, 
            status_payment: "Pending",
            user: profile._id,
            paypwd: data.paypwd
        };

        setLoad(true);
        axios.post(`${process.env.REACT_APP_API_URL}/payment/withDraw`, formData)
            .then(() => {
                setLoad(false); 
                swal("Thông báo", "Tạo yêu cầu rút tiền thành công!", "success")
                .then(() => navigate("/profile"));
            })
            .catch((err) => {
                setLoad(false);
                const errorMsg = err.response?.data?.message || "Đã có lỗi xảy ra";
                swal("Thất bại", errorMsg !== "internal server error" ? errorMsg : "Lỗi hệ thống", "error");
            });
    };

    const handleSelectBank = (bankItem) => {
        const fullName = `${bankItem.shortName} - ${bankItem.vn_name}`;
        setBankValue("name_bank", fullName); 
        setSearchTerm(fullName);             
        setIsOpen(false);                    
    };

    // HÀM SUBMIT GỘP CHO NGÂN HÀNG (Tạo MK + Tạo NH)
    const onSubmitAddBank = async (data) => {
        if (needsPayPwd) {
            if (!data.new_paypwd || data.new_paypwd.length < 4) {
                return swal("Lỗi", "Mật khẩu rút tiền phải từ 4 ký tự trở lên", "warning");
            }
            if (data.new_paypwd !== data.confirm_paypwd) {
                return swal("Lỗi", "Mật khẩu xác nhận không khớp", "error");
            }
        }

        setLoad(true);
        try {
            // 1. Gọi API cập nhật mật khẩu rút tiền nếu cần
            if (needsPayPwd) {
                await axios.post(`${process.env.REACT_APP_API_URL}/auth/updatepaypwd`, { paypwd: data.new_paypwd });
                setProfile({ ...profile, paypwd: data.new_paypwd });
                setNeedsPayPwd(false); // Tắt cờ sau khi cập nhật thành công
            }

            // 2. Gọi API thêm ngân hàng
            const formData = {
                name_bank: data.name_bank,
                stk: data.stk,
                fullname: data.fullname,
                user: profile._id
            };
            await axios.post(`${process.env.REACT_APP_API_URL}/bank/create`, formData);

            setLoad(false);
            swal("Thành Công", "Thêm ngân hàng và thiết lập thành công", "success").then(() => {
                resetBankForm();
                setSearchTerm("");
                setShowAddBankPopup(false);
                fetchBankData("VND"); 
            });

        } catch (err) {
            setLoad(false);
            const msg = err.response?.data?.message !== "internal server error" ? err.response?.data?.message : "Đã có lỗi xảy ra";
            swal("Thất bại", msg, "error");
        }
    };

    // HÀM SUBMIT GỘP CHO USDT (Tạo MK + Tạo USDT)
    const onSubmitAddUsdt = async (data) => {
        if (needsPayPwd) {
            if (!data.new_paypwd || data.new_paypwd.length < 4) {
                return swal("Lỗi", "Mật khẩu rút tiền phải từ 4 ký tự trở lên", "warning");
            }
            if (data.new_paypwd !== data.confirm_paypwd) {
                return swal("Lỗi", "Mật khẩu xác nhận không khớp", "error");
            }
        }

        setLoad(true);
        try {
            // 1. Gọi API cập nhật mật khẩu rút tiền nếu cần
            if (needsPayPwd) {
                await axios.post(`${process.env.REACT_APP_API_URL}/auth/updatepaypwd`, { paypwd: data.new_paypwd });
                setProfile({ ...profile, paypwd: data.new_paypwd });
                setNeedsPayPwd(false);
            }

            // 2. Gọi API thêm ví USDT
            const formData = {
                name_bank: data.network, 
                stk: data.address,
                fullname: "USDT WALLET", 
                user: profile._id
            };
            await axios.post(`${process.env.REACT_APP_API_URL}/bank/create`, formData);

            setLoad(false);
            swal("Thành Công", "Thêm ví USDT và thiết lập thành công", "success").then(() => {
                resetUsdtForm();
                setShowAddUsdtPopup(false);
                fetchBankData("USDT"); 
            });

        } catch (err) {
            setLoad(false);
            const msg = err.response?.data?.message !== "internal server error" ? err.response?.data?.message : "Đã có lỗi xảy ra";
            swal("Thất bại", msg, "error");
        }
    };

    const SyncIcon = () => (
        <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="23 4 23 10 17 10"></polyline><polyline points="1 20 1 14 7 14"></polyline><path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"></path></svg>
    );

    const currentAccounts = withdrawMethod === 'VND' ? vndBanks : usdtBanks;
    const isShowingPopup = showAddBankPopup || showAddUsdtPopup || showPendingPopup;

    return (
        <div style={{ display: "flex", flexDirection: "column", height: "100vh", background: "#f4f6f8", overflow: "hidden" }}>
            
            <style dangerouslySetInnerHTML={{__html: `
                * { font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif; box-sizing: border-box; }
                body { background-color: #f4f6f8; margin: 0; padding: 0; color: #333; }
                
                .w-app-main {
                    position: fixed; top: 0; bottom: 0; left: 0; right: 0; 
                    margin: 0 auto; max-width: 540px; background: #f4f6f8; 
                    display: flex; flex-direction: column; overflow-y: auto; overflow-x: hidden;
                    z-index: 10;
                }
                .w-app-main::-webkit-scrollbar { display: none; }
                .w-app-main { -ms-overflow-style: none; scrollbar-width: none; }

                .w-header {
                    display: flex; align-items: center; justify-content: space-between;
                    height: 50px; padding: 0 15px; border-bottom: 1px solid #f0f0f0; background: #fff;
                    position: sticky; top: 0; z-index: 50;
                }
                .w-header-back { cursor: pointer; display: flex; align-items: center; justify-content: center; }
                .w-header-title { font-size: 16px; font-weight: 700; color: #333; flex: 1; text-align: center; margin-right: -24px;}
                .w-header-right { cursor: pointer; color: #f39c12; display: flex; align-items: center;}

                .w-bal-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 10px; padding: 15px; }
                .w-bal-card { background: #fff; border-radius: 10px; padding: 15px; box-shadow: 0 2px 5px rgba(0,0,0,0.02); }
                .w-bal-top { display: flex; justify-content: space-between; align-items: center; margin-bottom: 25px; color: #666; font-size: 13px;}
                .w-bal-top.orange { color: #e67e22; }
                .w-bal-bottom { display: flex; justify-content: space-between; align-items: flex-end; }
                .w-bal-amount { font-size: 20px; font-weight: bold; color: #333; }
                
                .w-icon-circle { width: 30px; height: 30px; border-radius: 50%; border: 2px solid #555; display: flex; align-items: center; justify-content: center; }
                .w-icon-diamond { width: 10px; height: 10px; background: #555; transform: rotate(45deg); }

                .w-third-party {
                    background: #fff; margin: 0 15px 15px 15px; border-radius: 8px; padding: 15px;
                    display: flex; justify-content: space-between; align-items: center;
                    font-size: 14px; font-weight: 500; cursor: pointer; box-shadow: 0 2px 5px rgba(0,0,0,0.02);
                }

                .w-section { padding: 0 15px 15px 15px; }
                .w-label-center { font-size: 13px; color: #555; margin-bottom: 15px; font-weight: 500; text-align: center; }
                
                .w-methods { display: flex; gap: 10px; margin-bottom: 20px;}
                .w-method-btn {
                    flex: 1; display: flex; align-items: center; justify-content: center; gap: 8px;
                    padding: 12px 0; border-radius: 6px; font-size: 14px; font-weight: 500;
                    border: 1px solid #e0e0e0; background: #fff; cursor: pointer; color: #2ba1d8; transition: 0.2s;
                }
                .w-method-btn.active { border-color: #2ba1d8; background: #f4fafe; }
                .w-method-btn.inactive { color: #888; }
                
                .w-bank-select-wrap {
                    position: relative; background: #fff; border: 1px solid #e0e0e0; border-radius: 6px;
                    display: flex; align-items: center; margin-bottom: 20px;
                }
                .w-bank-select-wrap select {
                    width: 100%; padding: 14px 35px 14px 15px; border: none; background: transparent;
                    font-size: 14px; color: #333; outline: none; appearance: none; cursor: pointer; font-weight: 500;
                }
                .w-bank-select-arrow { position: absolute; right: 15px; pointer-events: none; color: #888; }

                .w-amount-grid { display: grid; grid-template-columns: repeat(4, 1fr); gap: 8px; margin-bottom: 20px; }
                .w-amount-btn {
                    border: 1px solid #e0e0e0; border-radius: 4px; padding: 10px 0;
                    text-align: center; font-size: 13px; font-weight: 500; color: #555;
                    background: #fff; cursor: pointer;
                }
                .w-amount-btn:active { background: #f0f0f0; }

                .w-input-group { margin-bottom: 20px; }
                .w-input-label { font-size: 14px; font-weight: 700; color: #333; margin-bottom: 8px; text-align: center; display: block; }
                .w-input-wrap { position: relative; display: flex; align-items: center; }
                .w-input {
                    width: 100%; padding: 14px 70px 14px 15px; border: 1px solid #e0e0e0; border-radius: 6px;
                    font-size: 15px; outline: none; transition: border 0.3s;
                }
                .w-input:focus { border-color: #2ba1d8; }
                .w-input-action { position: absolute; right: 15px; font-size: 14px; color: #2ba1d8; font-weight: 600; cursor: pointer; }
                .w-input-icon { position: absolute; right: 15px; color: #888; cursor: pointer; display: flex; align-items: center; }

                .w-footer-warn { font-size: 12px; color: #e74c3c; margin-bottom: 20px; text-align: center;}
                .w-submit-btn {
                    width: 100%; background: #2ba1d8; color: #fff; border: none;
                    border-radius: 6px; padding: 14px 0; font-size: 16px; font-weight: 600;
                    cursor: pointer; transition: opacity 0.2s;
                }
                .w-submit-btn:disabled { background: #999; cursor: not-allowed; }

                /* MODAL POPUP */
                .b-modal-overlay {
                    position: fixed; top: 0; left: 0; right: 0; bottom: 0;
                    background: rgba(0,0,0,0.6); z-index: 9999;
                    display: flex; align-items: center; justify-content: center;
                    animation: fadeIn 0.2s ease-out;
                }
                .b-modal-content {
                    background: #fff; width: 90%; max-width: 400px; max-height: 85vh; overflow-y: auto;
                    border-radius: 12px; padding: 20px;
                    position: relative; box-shadow: 0 4px 20px rgba(0,0,0,0.1);
                    animation: slideUp 0.3s ease-out;
                }
                .b-modal-content::-webkit-scrollbar { display: none; }
                .b-modal-title { font-size: 18px; font-weight: bold; color: #333; text-align: center; margin-bottom: 20px;}
                .b-modal-close { position: absolute; top: 15px; right: 15px; cursor: pointer; color: #888; }
                
                .b-input-group { margin-bottom: 15px; position: relative;}
                .b-input-group label { display: block; font-size: 13px; font-weight: 600; color: #555; margin-bottom: 6px; }
                .b-input-group input, .b-input-group select { 
                    width: 100%; padding: 12px; border: 1px solid #e0e0e0; border-radius: 6px; 
                    font-size: 14px; outline: none; transition: border 0.2s; background: #fff;
                }
                .b-input-group input:focus, .b-input-group select:focus { border-color: #2ba1d8; }
                .b-error-text { color: red; font-size: 12px; margin-top: 4px;}

                .b-dropdown-list {
                    position: absolute; z-index: 10; top: calc(100% + 2px); left: 0; right: 0;
                    background: #fff; border: 1px solid #ccc; max-height: 250px; overflow-y: auto;
                    list-style: none; padding: 0; margin: 0; border-radius: 6px;
                    box-shadow: 0 4px 12px rgba(0,0,0,0.15);
                }
                .b-dropdown-item {
                    padding: 10px 12px; cursor: pointer; display: flex; align-items: center; gap: 12px;
                    border-bottom: 1px solid #f0f0f0; transition: background 0.2s;
                }
                .b-dropdown-item:hover { background: #f5f5f5; }
                .b-dropdown-item img { width: 35px; height: 35px; object-fit: contain; border-radius: 4px; border: 1px solid #eee; padding: 2px;}
                
                @keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }
                @keyframes slideUp { from { transform: translateY(20px); opacity: 0; } to { transform: translateY(0); opacity: 1; } }
            `}} />

            {(load || initialLoading) && <div className="loading" style={{zIndex: 99999}}><div className="loader"></div></div>}

            <div className="w-app-main">
                <AnimatedPage>
                    {/* ===== HEADER ===== */}
                    <div className="w-header">
                        <div className="w-header-back" onClick={handleBackClick}>
                            <svg viewBox="0 0 24 24" width="24" height="24" fill="#333"><path d="M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z"/></svg>
                        </div>
                        <div className="w-header-title">Rút điểm</div>
                        <Link to="/transaction/history" state={{ filterType: 'rut' }} className="w-header-right">
                            <img src={require("../../images/moi/history_dark.png")} alt="Lịch sử" style={{ width: "24px", height: "24px", objectFit: "contain" }} />
                        </Link>
                    </div>

                    {!isShowingPopup && (
                        <>
                            {/* ===== THẺ SỐ DƯ ===== */}
                            <div className="w-bal-grid">
                                <div className="w-bal-card">
                                    <div className="w-bal-top">
                                        Số dư
                                        <span style={{cursor:'pointer'}} onClick={() => fetchBankData()}><SyncIcon /></span>
                                    </div>
                                    <div className="w-bal-bottom">
                                        <div className="w-bal-amount">{profile?.money ? parseFloat(profile.money).toLocaleString('vi-VN') : "0.000"}</div>
                                        <div className="w-icon-circle">
                                            <div className="w-icon-diamond"></div>
                                        </div>
                                    </div>
                                </div>
                                <div className="w-bal-card" style={{cursor: 'pointer'}} onClick={() => setShowPendingPopup(true)}>
                                    <div className="w-bal-top orange">
                                        <div>
                                            <svg viewBox="0 0 24 24" width="14" height="14" fill="currentColor" style={{marginRight:'4px', verticalAlign:'text-bottom'}}><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"/></svg>
                                            Chi tiết
                                        </div>
                                        <span style={{color:'#666'}}><SyncIcon /></span>
                                    </div>
                                    <div className="w-bal-bottom">
                                        <div>
                                            <div style={{fontSize:'12px', color:'#666', marginBottom:'4px'}}>Số dư chờ xử lí</div>
                                            <div className="w-bal-amount" style={{fontSize: '18px'}}>{pendingAmount.toLocaleString('vi-VN')}</div>
                                        </div>
                                        <svg viewBox="0 0 24 24" width="28" height="28" fill="#555"><path d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z"/></svg>
                                    </div>
                                </div>
                            </div>

                            <div className="w-third-party">
                                Số dư thuộc bên thứ ba
                                <svg viewBox="0 0 24 24" width="20" height="20" fill="#888"><path d="M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z"/></svg>
                            </div>

                            {/* ===== FORM RÚT TIỀN ===== */}
                            <form className="w-section" onSubmit={handleWithdraw(onSubmitWithdraw)}>
                                
                                <div className="w-label-center">Vui lòng chọn phương thức rút điểm</div>
                                <div className="w-methods">
                                    <div className={`w-method-btn ${withdrawMethod === 'VND' ? 'active' : 'inactive'}`} onClick={() => handleSwitchMethod('VND')}>
                                        <svg viewBox="0 0 24 24" width="20" height="20" fill="#e74c3c"><circle cx="12" cy="12" r="10" /><path fill="#f1c40f" d="M12 6.5l1.5 4.5h4.5l-3.5 2.5 1.5 4.5-4-3-4 3 1.5-4.5-3.5-2.5h4.5z"/></svg>
                                        VND
                                    </div>
                                    <div className={`w-method-btn ${withdrawMethod === 'USDT' ? 'active' : 'inactive'}`} onClick={() => handleSwitchMethod('USDT')}>
                                        <svg viewBox="0 0 24 24" width="20" height="20" fill="#2ecc71"><circle cx="12" cy="12" r="10"/><path fill="#fff" d="M8 9h8v2h-3v6h-2v-6H8z"/></svg>
                                        USDT
                                    </div>
                                </div>

                                <div className="w-label-center">Chọn tài khoản</div>
                                <div className="w-bank-select-wrap">
                                    <select {...regWithdraw("detail", { required: true })}>
                                        <option value="">-- Chọn tài khoản nhận tiền --</option>
                                        {currentAccounts && currentAccounts.map((item, index) => {
                                            const safeStk = String(item.stk || "");
                                            let maskedStk = safeStk;
                                            if (safeStk.length > 4) {
                                                maskedStk = "*".repeat(safeStk.length - 4) + safeStk.slice(-4);
                                            } else {
                                                maskedStk = "****";
                                            }
                                            
                                            return (
                                                <option key={index} value={`${item.name_bank} - ${item.fullname} - ${item.stk}`}>
                                                    {withdrawMethod === 'VND' 
                                                        ? `${item.fullname} - ${maskedStk} - ${item.name_bank}` 
                                                        : `${item.name_bank} - ${String(item.stk).slice(0, 6)}...${String(item.stk).slice(-4)}`}
                                                </option>
                                            );
                                        })}
                                    </select>
                                    <div className="w-bank-select-arrow">
                                        <svg viewBox="0 0 24 24" width="20" height="20" fill="currentColor"><path d="M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z"/></svg>
                                    </div>
                                </div>
                                {wErrors.detail && <div style={{color:'red', fontSize:'12px', textAlign:'center', marginTop:'-15px', marginBottom:'15px'}}>Vui lòng chọn tài khoản</div>}

                                <div className="w-amount-grid">
                                    {[100000, 200000, 500000, 1000000, 2000000, 5000000, 10000000, 50000000].map((val, idx) => {
                                        let label = val >= 1000000 ? (val/1000000) + "M" : (val/1000) + "K";
                                        return (
                                            <div key={idx} className="w-amount-btn" onClick={() => handleQuickAmount(val)}>
                                                {label}
                                            </div>
                                        )
                                    })}
                                </div>

                                <div className="w-input-group">
                                    <label className="w-input-label">Số điểm rút</label>
                                    <div className="w-input-wrap">
                                        <input 
                                            className="w-input" 
                                            type="text" 
                                            placeholder="Nhập số điểm rút" 
                                            value={newMoney}
                                            {...regWithdraw("money", { required: true })}
                                            onChange={(e) => {
                                                const val = e.target.value.replace(/\D/g, "");
                                                const formatted = val ? Number(val).toLocaleString('vi-VN') : "";
                                                setNewMoney(formatted);
                                                setWValue("money", formatted);
                                            }}
                                        />
                                        <div className="w-input-action" onClick={handleMaxAmount}>Tối đa</div>
                                    </div>
                                    
                                    {withdrawMethod === "USDT" && newMoney && (
                                        <div style={{ marginTop: "8px", fontSize: "13px", color: "#2ecc71", fontWeight: "600", textAlign: "center" }}>
                                            ≈ {(Number(newMoney.replaceAll(".", "")) / usdtRate).toFixed(2)} USDT 
                                            <span style={{color: "#888", fontSize: "12px", fontWeight: "normal"}}> (Tỉ giá: 1 USDT = {usdtRate.toLocaleString("vi-VN")}₫)</span>
                                        </div>
                                    )}
                                </div>

                                <div className="w-input-group">
                                    <label className="w-input-label">Mật khẩu giao dịch:</label>
                                    <div className="w-input-wrap">
                                        <input 
                                            className="w-input" 
                                            type={showPwd ? "text" : "password"} 
                                            placeholder="Nhập mật khẩu giao dịch" 
                                            {...regWithdraw("paypwd", { required: true })}
                                        />
                                        <div className="w-input-icon" onClick={() => setShowPwd(!showPwd)}>
                                            {showPwd ? (
                                                <svg viewBox="0 0 24 24" width="20" height="20" fill="currentColor"><path d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"/></svg>
                                            ) : (
                                                <svg viewBox="0 0 24 24" width="20" height="20" fill="currentColor"><path d="M12 7c2.76 0 5 2.24 5 5 0 .65-.13 1.26-.36 1.83l2.92 2.92c1.51-1.28 2.7-2.89 3.43-4.75-1.73-4.39-6-7.5-11-7.5-1.4 0-2.74.25-3.98.7l2.16 2.16C10.74 7.13 11.35 7 12 7zM2 4.27l2.28 2.28.46.46C3.08 8.3 1.78 10.02 1 12c1.73 4.39 6 7.5 11 7.5 1.55 0 3.03-.3 4.38-.84l.42.42L19.73 22 21 20.73 3.27 3 2 4.27zM7.53 9.8l1.55 1.55c-.05.21-.08.43-.08.65 0 1.66 1.34 3 3 3 .22 0 .44-.03.65-.08l1.55 1.55c-.67.33-1.41.53-2.2.53-2.76 0-5-2.24-5-5 0-.79.2-1.53.53-2.2zM11.84 9.02l3.15 3.15.02-.16c0-1.66-1.34-3-3-3l-.17.01z"/></svg>
                                            )}
                                        </div>
                                    </div>
                                </div>

                                <div className="w-footer-warn">
                                    Để tránh xảy ra sai sót, vui lòng nhập chính xác mật khẩu giao dịch
                                </div>

                                <button type="submit" className="w-submit-btn" disabled={load || currentAccounts.length === 0}>
                                    {load ? "Đang xử lý..." : "Xác nhận"}
                                </button>
                            </form>
                        </>
                    )}
                </AnimatedPage>
            </div>

            {/* POPUP THÔNG BÁO SỐ DƯ CHỜ XỬ LÝ */}
            {showPendingPopup && (
                <div className="b-modal-overlay">
                    <div className="b-modal-content" style={{ padding: 0 }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '15px', borderBottom: '1px solid #eee' }}>
                            <div style={{ width: '24px' }}></div>
                            <div style={{ fontSize: '16px', fontWeight: 'bold' }}>Số dư chưa xử lí là gì</div>
                            <div style={{ cursor: 'pointer' }} onClick={() => setShowPendingPopup(false)}>
                                <svg viewBox="0 0 24 24" width="24" height="24" fill="#333"><path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/></svg>
                            </div>
                        </div>
                        <div style={{ padding: '20px' }}>
                            <div style={{ fontSize: '14px', color: '#555', marginBottom: '10px' }}>
                                Số dư chưa xử lí bao gồm những trường hợp dưới đây:
                            </div>
                            <div style={{ fontSize: '14px', color: '#333', marginBottom: '20px', lineHeight: '1.6' }}>
                                1. Tài khoản có đơn rút điểm đang xử lí: <strong style={{color: '#e74c3c'}}>{pendingAmount.toLocaleString('vi-VN')} VND</strong>
                            </div>
                            <button className="w-submit-btn" onClick={() => setShowPendingPopup(false)}>Gửi</button>
                        </div>
                    </div>
                </div>
            )}

            {/* POPUP ADD BANK (VND) */}
            {showAddBankPopup && (
                <div className="b-modal-overlay">
                    <div className="b-modal-content">
                        <div className="b-modal-close" onClick={handleBackClick}>
                            <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor"><path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/></svg>
                        </div>
                        <div className="b-modal-title">Liên kết ngân hàng</div>
                        
                        <div style={{fontSize:'13px', color:'#e67e22', marginBottom:'15px', textAlign:'center', background:'#fff3e0', padding:'10px', borderRadius:'8px'}}>
                            Bạn chưa liên kết ngân hàng. Vui lòng cập nhật để tiếp tục rút tiền!
                        </div>

                        <form onSubmit={handleAddBank(onSubmitAddBank)}>
                            <div className="b-input-group" style={{ zIndex: 20 }}>
                                <label>Chọn tên ngân hàng</label>
                                <input
                                    type="text"
                                    placeholder="Tìm kiếm và chọn ngân hàng..."
                                    value={searchTerm}
                                    onChange={(e) => setSearchTerm(e.target.value)}
                                    onFocus={() => setIsOpen(true)}
                                />
                                {isOpen && filteredBanksList.length > 0 && (
                                    <ul className="b-dropdown-list">
                                        {filteredBanksList.map((bankItem, index) => (
                                            <li 
                                                key={index} 
                                                className="b-dropdown-item"
                                                onClick={() => handleSelectBank(bankItem)}
                                            >
                                                <img src={bankItem.logo} alt={bankItem.shortName} />
                                                <span>{bankItem.shortName} - {bankItem.vn_name}</span>
                                            </li>
                                        ))}
                                    </ul>
                                )}
                                <input type="hidden" {...regBank("name_bank", { required: true })} />
                                {bErrors.name_bank && <div className="b-error-text">Vui lòng chọn ngân hàng từ danh sách</div>}
                            </div>
                            
                            <div className="b-input-group">
                                <label>Số tài khoản</label>
                                <input type="number" placeholder="Nhập số tài khoản" {...regBank("stk", { required: true })} />
                                {bErrors.stk && <div className="b-error-text">Bắt buộc nhập</div>}
                            </div>
                            
                            <div className="b-input-group">
                                <label>Tên chủ tài khoản (Viết in hoa không dấu)</label>
                                <input type="text" placeholder="NGUYEN VAN A" {...regBank("fullname", { required: true })} />
                                {bErrors.fullname && <div className="b-error-text">Bắt buộc nhập</div>}
                            </div>

                            {/* HIỂN THỊ TRƯỜNG NHẬP MẬT KHẨU NẾU NGƯỜI DÙNG CHƯA CÓ */}
                            {needsPayPwd && (
                                <>
                                    <div className="b-input-group" style={{ marginTop: '20px', borderTop: '1px dashed #ccc', paddingTop: '15px' }}>
                                        <label style={{color: '#2ba1d8'}}>Thiết lập mật khẩu rút tiền</label>
                                        <input type="password" placeholder="Nhập mật khẩu mới (ít nhất 4 ký tự)" {...regBank("new_paypwd", { required: true })} />
                                        {bErrors.new_paypwd && <div className="b-error-text">Bắt buộc nhập mật khẩu rút tiền</div>}
                                    </div>
                                    <div className="b-input-group">
                                        <label style={{color: '#2ba1d8'}}>Xác nhận lại mật khẩu</label>
                                        <input type="password" placeholder="Nhập lại mật khẩu trên" {...regBank("confirm_paypwd", { required: true })} />
                                        {bErrors.confirm_paypwd && <div className="b-error-text">Bắt buộc nhập xác nhận mật khẩu</div>}
                                    </div>
                                    <div style={{fontSize:'12px', color:'#e74c3c', marginBottom:'15px', textAlign:'center'}}>
                                        * Mật khẩu này sẽ được dùng cho mọi giao dịch rút tiền sau này.
                                    </div>
                                </>
                            )}

                            <button type="submit" className="w-submit-btn" style={{marginTop: '10px'}} disabled={load}>
                                {load ? "Đang xử lý..." : "Lưu ngân hàng"}
                            </button>
                        </form>
                    </div>
                </div>
            )}

            {/* POPUP ADD USDT WALLET */}
            {showAddUsdtPopup && (
                <div className="b-modal-overlay">
                    <div className="b-modal-content">
                        <div className="b-modal-close" onClick={() => handleSwitchMethod("VND")}>
                            <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor"><path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/></svg>
                        </div>
                        <div className="b-modal-title">Liên kết ví USDT</div>
                        
                        <div style={{fontSize:'13px', color:'#2ecc71', marginBottom:'15px', textAlign:'center', background:'#e8f8f5', padding:'10px', borderRadius:'8px'}}>
                            Bạn chưa thêm địa chỉ ví USDT nào. Vui lòng thêm để tiếp tục.
                        </div>

                        <form onSubmit={handleAddUsdt(onSubmitAddUsdt)}>
                            <div className="b-input-group">
                                <label>Mạng lưới (Network)</label>
                                <select {...regUsdt("network", { required: true })}>
                                    <option value="TRC20">TRC20 (Mạng Tron)</option>
                                    <option value="BEP20">BEP20 (Binance Smart Chain)</option>
                                </select>
                            </div>
                            
                            <div className="b-input-group">
                                <label>Địa chỉ ví</label>
                                <input type="text" placeholder="Nhập địa chỉ ví USDT..." {...regUsdt("address", { required: true })} />
                                {uErrors.address && <div className="b-error-text">Bắt buộc nhập địa chỉ ví</div>}
                            </div>

                            {/* HIỂN THỊ TRƯỜNG NHẬP MẬT KHẨU NẾU NGƯỜI DÙNG CHƯA CÓ */}
                            {needsPayPwd && (
                                <>
                                    <div className="b-input-group" style={{ marginTop: '20px', borderTop: '1px dashed #ccc', paddingTop: '15px' }}>
                                        <label style={{color: '#2ba1d8'}}>Thiết lập mật khẩu rút tiền</label>
                                        <input type="password" placeholder="Nhập mật khẩu mới (ít nhất 4 ký tự)" {...regUsdt("new_paypwd", { required: true })} />
                                        {uErrors.new_paypwd && <div className="b-error-text">Bắt buộc nhập mật khẩu rút tiền</div>}
                                    </div>
                                    <div className="b-input-group">
                                        <label style={{color: '#2ba1d8'}}>Xác nhận lại mật khẩu</label>
                                        <input type="password" placeholder="Nhập lại mật khẩu trên" {...regUsdt("confirm_paypwd", { required: true })} />
                                        {uErrors.confirm_paypwd && <div className="b-error-text">Bắt buộc nhập xác nhận mật khẩu</div>}
                                    </div>
                                    <div style={{fontSize:'12px', color:'#e74c3c', marginBottom:'15px', textAlign:'center'}}>
                                        * Mật khẩu này sẽ được dùng cho mọi giao dịch rút tiền sau này.
                                    </div>
                                </>
                            )}

                            <button type="submit" className="w-submit-btn" style={{marginTop: '10px', background: '#2ecc71'}} disabled={load}>
                                {load ? "Đang xử lý..." : "Lưu địa chỉ ví"}
                            </button>
                        </form>
                    </div>
                </div>
            )}

        </div>
    );
}

export default WithDraw;